var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00EADB",
    d: "M12 18.857a6.857 6.857 0 1 0 0-13.714a6.857 6.857 0 0 0 0 13.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E756CB",
    d: "M5.155 12.429a6.857 6.857 0 0 0 13.689 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAury0)",
    d: "M17.674 8.147c.257.386.484.797.664 1.23c-.6.12-1.243.322-1.555.789c-.035.051.004.12.068.12c.407 0 1.136.008 1.809.077c.128.527.197 1.071.197 1.637h-3.742l1.758-3.883a2.7 2.7 0 0 1 .801.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAury1)",
    d: "M16.17 6.557a6.83 6.83 0 0 0-6.76-.907c1.633.321 2.52.638 2.816.78c.038.017.03.068-.013.072c-1.17.283-2.906.343-4.307.193l.827 1.839a.24.24 0 0 1 .116.051c.223.193.625.369 1.2.373c.008 0 .021.013.021.026q-.002.013-.017.021A7 7 0 0 1 9 9.13l.137.3h5.743l.248-.558c-.235.056-.583.12-.934.129c-.009 0-.013-.013 0-.017a6.5 6.5 0 0 0 1.136-.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAury2)",
    d: "M6.848 7.474a7 7 0 0 0-.527.682c.227.214.557.377 1.016.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAury3)",
    d: "m13.705 12l.583-1.286H9.715L10.294 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAury4)",
    d: "M10.491 12.429h3.017L12 15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAury5)",
    d: "m8.884 12l-1.17-2.571h.013l-.026-.06l.013.06a4.18 4.18 0 0 0-2.537 1.868a7 7 0 0 0-.034.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAury6)",
    d: "M9.077 12.429L12 18.857a6.857 6.857 0 0 1-6.845-6.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAury7)",
    d: "M14.923 12.429h3.921A6.857 6.857 0 0 1 12 18.857z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAury0",
    x1: -6.278,
    x2: -6.278,
    y1: -5.274,
    y2: 43.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E756CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8F79D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#668AD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAury1",
    x1: 11.936,
    x2: 11.936,
    y1: 5.154,
    y2: 49.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E756CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8F79D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAury2",
    x1: 81.815,
    x2: 81.815,
    y1: -24.149,
    y2: 148.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E756CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8F79D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAury3",
    x1: 11.993,
    x2: 11.993,
    y1: -54.352,
    y2: 92.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E756CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8F79D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#668AD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAury4",
    x1: 12,
    x2: 12,
    y1: -24.976,
    y2: 31.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8F79D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#668AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAury5",
    x1: 30.278,
    x2: 30.278,
    y1: -16.908,
    y2: 54.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E756CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8F79D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#668AD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAury6",
    x1: 18.857,
    x2: 18.857,
    y1: -10.421,
    y2: 18.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8F79D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#668AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAury7",
    x1: 11.999,
    x2: 11.999,
    y1: 5.143,
    y2: 18.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8F79D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#668AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E9C9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAury);
export default __webpack_public_path__ + "static/media/aury.5321a2c7688921ef979badf0e3c04e59.svg";
export { ForwardRef as ReactComponent };